import { ArpMedia } from '@arpeggi/shared'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { useIsEditionHolder } from './useIsEditionHolder'

export const useIsArpTokenGateHolder = (arp: ArpMedia | IArpMedia) => {
  return useIsEditionHolder(arp?.tokenGate?.contractAddress, arp?.tokenGate?.chain)
}
